// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image[data-v-3d9a6a29]{width:100%}.h-full[data-v-3d9a6a29]{height:100%}.content-on-image[data-v-3d9a6a29]{position:absolute;height:100%;top:0;bottom:0;left:0;right:0}.relative[data-v-3d9a6a29]{position:relative}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
